import view from "./view.jpg";
import view2 from "./view2.jpg";
import sip from "./sip.jpg";
import lick from "./lick.jpg";
import breakfast from "./breakfast.jpg";
import reflection from "./reflection.jpg";
import morning from "./morning.jpg";
import preen from "./preen.jpg";
import slip from "./slip.jpg";
import boobs from "./boobs.jpg";
import curves from "./curves.jpg";
import bra from "./bra.jpg";
import vhs from "./vhs.jpg";

export const images = [
	view,
	view2,
	sip,
	lick,
	breakfast,
	morning,
	reflection,
	preen,
	slip,
	boobs,
	curves,
	bra,
	vhs,
];
